export default __webpack_public_path__ + "static/media/Greenline-Logo-fullColor-DK.91b9f284.svg";